
const initialState = {
  AppliedCodeName: "",
};

const testSlice = (state = initialState, action) => {
    console.log("Add_Coupon_Code", action.payload);
  switch (action.type) {
    case "AppliedCouponCodeName":
      console.log("AppliedCouponCodeName", action.payload);
      return Object.assign({}, state, {
        AppliedCodeName: action.payload,
      });
  }
  return state;
};
export default testSlice;
